import { render, staticRenderFns } from "./trace.vue?vue&type=template&id=21828b68&scoped=true&"
import script from "./trace.vue?vue&type=script&lang=js&"
export * from "./trace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21828b68",
  null
  
)

export default component.exports